import { Controller } from "@hotwired/stimulus"

// Mostra/esconde o input de CPF/CNPJ baseado no resolver_kind escolhido.
// Só relevante quando kind=fixed_cpf_cnpj — os outros 2 não usam resolver_value.
export default class extends Controller {
  static targets = ["kind", "resolverValueWrap"]

  connect() {
    this.toggle()
  }

  onKindChange() {
    this.toggle()
  }

  toggle() {
    if (this.kindTarget.value === "fixed_cpf_cnpj") {
      this.resolverValueWrapTarget.classList.remove("hidden")
    } else {
      this.resolverValueWrapTarget.classList.add("hidden")
    }
  }
}
